<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',
  onMounted() {
    window.addEventListener('beforeunload', this.handleRefresh());
  },
  onBeforeUnmount() {
    window.removeEventListener('beforeunload', this.handleRefresh());
  },
  methods: {
    handleRefresh() {
      console.log(this.$route.path)
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
</style>
